import registerEvent from '@/resources/register-event.js';

export default {
    inserted: function (el, binding) {
        const itemId = el.getAttribute('event-item-id');
        const text = el.getAttribute('event-text');
        const datasourceId = el.getAttribute('event-datasource-id');

        el.addEventListener('click', (evt) => {
            registerEvent.post(itemId, text, datasourceId);
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/register-event.js